import { LoadDoctorPendencies } from 'domain/usecases/doctor/load-doctor-pendencies'
import { DoctorRepository } from 'repository/interfaces/doctor-repository'

export class RemoteLoadDoctorPendencies implements LoadDoctorPendencies {
  private readonly doctorRepository: DoctorRepository

  constructor(doctorRepository: DoctorRepository) {
    this.doctorRepository = doctorRepository
  }

  load(
    params: LoadDoctorPendencies.Params
  ): Promise<LoadDoctorPendencies.Model> {
    return this.doctorRepository.loadDoctorPendencies(params)
  }
}

export type LoadDoctorPendenciesModel = LoadDoctorPendencies.Model
